import { FLOW_BUILDER2_PAGE_NS } from '../../i18n';
import { useFlowBuilder2PageContext } from '../../Context/useFlowBuilder2PageContext';
import { useFlowBuilder2PageStore } from '../../Store/useFlowBuilder2PageStore';
import { CodeOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { Skeleton } from '@mui/material';
import { ISwitcherButton, Switcher, BuildLayoutIcon, useEditorStore } from '@diana/core';
import { BuilderTypeEnum } from '../../Store/FlowBuilder2PageStore.types';

export const BuilderSwitcher = () => {
  const { t } = useTranslation(FLOW_BUILDER2_PAGE_NS);
  const { isLoading: isPageLoading } = useFlowBuilder2PageContext();

  const activeTab = useFlowBuilder2PageStore((store) => store.builderType);
  const setActiveTab = useFlowBuilder2PageStore((store) => store.setBuilderType);

  const setEnableAeAutoSelect = useEditorStore((store) => store.setEnableAeAutoSelect);

  const handleClick = () => {
    setEnableAeAutoSelect(true);
  };

  const buttons: ISwitcherButton[] = useMemo(() => {
    return [
      { name: BuilderTypeEnum.Nocode, text: t('labels.layout'), icon: BuildLayoutIcon },
      { name: BuilderTypeEnum.AdvancedEditor, text: t('labels.code'), icon: CodeOutlined },
    ];
  }, [t]);

  if (isPageLoading) return <Skeleton variant="rounded" width={170} height={36} />;

  return (
    <Switcher buttons={buttons} value={activeTab} setValue={setActiveTab} onClick={handleClick} />
  );
};
